module.exports = __webpack_public_path__ + "img/badge-fastest-lead-pickup-keyvue-green.219c4ea0.png";